/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Fair_Wren_PaceInputs */

const en_vivid_fair_wren_pace = /** @type {(inputs: Vivid_Fair_Wren_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-generated from label`)
};

const de_vivid_fair_wren_pace = /** @type {(inputs: Vivid_Fair_Wren_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch aus Bezeichnung generiert`)
};

/**
* | output |
* | --- |
* | "Auto-generated from label" |
*
* @param {Vivid_Fair_Wren_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vivid_fair_wren_pace = /** @type {((inputs?: Vivid_Fair_Wren_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Fair_Wren_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vivid_fair_wren_pace(inputs)
	return de_vivid_fair_wren_pace(inputs)
});